import { render, staticRenderFns } from "./browselist.vue?vue&type=template&id=975f4b9c"
import script from "./browselist.vue?vue&type=script&lang=js"
export * from "./browselist.vue?vue&type=script&lang=js"
import style0 from "./browselist.vue?vue&type=style&index=0&id=975f4b9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports